import { Col, Button, Row, Table, ButtonGroup } from "react-bootstrap";
import { handleFieldChange } from "../../Utils";

import { API_URL_V3 } from '../../data/config';

import React from "react";

import FieldGroup from "../../components/FieldGroup";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import API from "../../services/API";


class BitbucketDNSDomainChecker extends React.Component {
    constructor() {
        super();

        this.handleFieldChange = handleFieldChange.bind(this);

        this.load_tasks = this.load_tasks.bind(this);
        this.on_create = this.on_create.bind(this);

        this.state = {
            loading: true,
            bitbucket_dns_domain_checker_tasks: [],
            bitbucket_dns_domain_checker_tasks_results_count: {},
            domains: "",
        }
    }

    componentDidMount() {
        this.load_tasks().catch(console.error);
    }

    async load_tasks() {
        const bitbucket_dns_domain_checker_tasks = await API.BitbucketDnsDomainChecker.get();
        const bitbucket_dns_domain_checker_tasks_results_count = await API.BitbucketDnsDomainChecker.get_results_distinct();

        this.setState((prev) => ({ ...prev, bitbucket_dns_domain_checker_tasks, bitbucket_dns_domain_checker_tasks_results_count, loading: false }));
    }

    async on_create() {
        const domains = this.state.domains.split(',').map((string) => string.trim());

        this.setState((prev) => ({ ...prev, loading: true }));

        await API.BitbucketDnsDomainChecker.create(domains);

        return this.load_tasks();
    }

    async on_download(id) {
        window.open(`${API_URL_V3}/bullmq-task-consumers/bitbucket_dns_domain_checker/download/${id}`, '_blank');
    }

    render() {
        return (
            <Container loading={this.state.loading}>
                <Heading title="Webserver/Bitbucket/DNS Domains Checker"/>

                <div>
                    <Row>
                        <Col lg={12}>
                            <FieldGroup
                                type="text"
                                name="domains"
                                label="Domains separated by comma:"
                                onChange={this.handleFieldChange}
                                value={this.state.day}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={2}>
                                <Button onClick={this.on_create} bsStyle={"success"}>Create</Button>
                        </Col>
                    </Row>
                </div>

                <div style={{ marginTop: '15px' }}>
                    <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <thead>
                            <tr>
                                <th>Task ID</th>
                                <th>Amount of domains</th>
                                <th>Created At</th>
                                <th>Amount of Processed</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.bitbucket_dns_domain_checker_tasks.map((task) => {
                                    const domains = JSON.parse(task.payload).domains;

                                    return (
                                        <tr key={task.id}>
                                            <td>{task.id}</td>
                                            <td>{domains.length}</td>
                                            <td>{task.created_at}</td>
                                            <td>{this.state.bitbucket_dns_domain_checker_tasks_results_count[task.id]}</td>
                                            <td>
                                                <ButtonGroup>
                                                    <Button onClick={() => this.on_download(task.id)} bsStyle={"success"}>Download</Button>
                                                </ButtonGroup>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                </div>
            </Container>
        )
    }
}

export default BitbucketDNSDomainChecker;



// WEBPACK FOOTER //
// ./src/scenes/BitbucketDNSDomainChecker/index.js